// 考虑到网站可能有好几个域名，所以单独提出来

// let API = '';

// if (process.env.NODE_ENV === 'development') {
//   // 开发环境直接连接后端
//   API = 'http://127.0.0.1:7002';
// } else {
//   // 生产环境使用相对路径
//   API = '';
// }

// export { API };
export const API = process.env.REACT_APP_API_URL;
